import { useState, useEffect } from 'react';
import { profileService } from '../services/dataService';

/**
 * Custom hook to fetch profile data from Firestore
 * @returns {Object} { profile, loading, error, refetch }
 */
export const useProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProfile = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const result = await profileService.getAll();
      
      if (result.success) {
        // Get the first profile document (should only be one)
        setProfile(result.data[0] || null);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return {
    profile,
    loading,
    error,
    refetch: fetchProfile
  };
};